export default __webpack_public_path__ + "static/media/vitamins.30485989.jpg";